import { render, staticRenderFns } from "./NotificationPage.vue?vue&type=template&id=d3b7874c&scoped=true"
import script from "./NotificationPage.vue?vue&type=script&lang=ts"
export * from "./NotificationPage.vue?vue&type=script&lang=ts"
import style0 from "./NotificationPage.vue?vue&type=style&index=0&id=d3b7874c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3b7874c",
  null
  
)

export default component.exports